export const FLOATING_WIDGET_TRIGGER_DEFAULT_OFFSET = 'bottom-6';
export const FLOATING_WIDGET_TRIGGER_DEFAULT_OFFSET_MOBILE = 'bottom-2';
export const FLOATING_WIDGET_TRIGGER_LIFT_OFFSET = 'bottom-24';

export const WIDGET_BODY_BOTTOM_OFFSET = 'bottom-24';
export const WIDGET_BODY_BOTTOM_OFFSET_MOBILE = 'bottom-8';
